module.exports = __webpack_public_path__ + "static/AvenirLTStd-Medium-4a29d71814898e7f217c40cf085d9784.otf";